import React, { Component } from 'react';

import { useParams, useNavigate, Link, } from 'react-router-dom';
import Pagination from "react-js-pagination";
import { apiUrl} from'../Config/Config';
import { lang } from '../Helpers/lang';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

//import { GET_CARLIST,GET_DELETECAR,GET_PRIORITYUPDATE } from '../../actions';


const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
  
class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      couponlist:'',
	  activePage: 1,
	  totalRecord: '',
	  search_all:'',
	  selectedStatus:'',
	  selectid:'',
    couponid:'',
    popupType:'',
    
    selectedFilOption:'',
    selectedFilvalue:'',
    };

   

    //this.props.getCarList(qs.stringify(postobject));

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    }

   
   componentDidMount() {
      // document.title = PageTitle('Car List');
      // if(localStorage.getItem('admin_id') === null){
      // this.props.history.push('/');
      // }
	  this.listloadedData()
   }
   
    listloadedData(postobject='') {
  var qs = require('qs');
   if(postobject!=''){
    var postobject = postobject
   }else{
    var postobject = {
      activePage: this.state.activePage,
      search_all: '',
      admin_id: localStorage.getItem('admin_id')  
      };
   }
  
 axios.post(apiUrl+"coupon/list",qs.stringify(postobject)).then(res => {
   
   if(res.data.status === 'success'){
	   console.log(res.data.couponlist,'-res.data')
       this.setState({couponlist: res.data, totalRecord: res.data.records_count}, function() {
         this.couponlist();
       });
   }else{
    this.setState({  couponlist: '', totalRecord: 0}, function() {
      this.couponlist();
    });
   }
 }); 
}

    handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});

      var qs = require('qs');

      var admin_id = localStorage.getItem("admin_id");

      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
	  this.listloadedData(postobject);
     // this.props.getCarList(qs.stringify(postobject))
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    var postObject = {             
      activePage   : this.state.activePage,
      search_all : value,
      admin_id: localStorage.getItem('admin_id')           
    };
    this.listloadedData(postObject)
    
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
         
           var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
            activePage   : 1,
            search_all : this.state.search_all,
            filterVal : this.state.selectedFilvalue,
            admin_id: admin_id         
          };
		  this.listloadedData(postObject);
          //console.log(postObject);
        //  this.props.getCarList(qs.stringify(postObject));
        
    }    

	deletecoupon(id){
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          coupon_id  :id
        };
      //this.props.getDeleteCar(qs.stringify(postObject));
      this.setState({couponid : id, popupType: 'delete'})
      $('.confirm-action-delete-message').html('Are you sure! you want to delete the coupon?');	
      $('.confirm-action-delete').addClass('show');	
	}
	sendCoupon(id){       
      this.setState({couponid : id, popupType: 'send'})
      $('.confirm-action-delete-message').html('Are you sure! you want to send the coupon notification to riders?');	
      $('.confirm-action-delete').addClass('show');	
	}

  couponlist() {
	 // console.log(this.state.couponlist,'couponlist')
    var couponlist = this.state.couponlist;
    if (couponlist != "undefined" && couponlist != null) {
      if (couponlist.status == "success") {
        if (Object.keys(couponlist).length > 0) {
          const couponlistDetails = couponlist.couponlist.map(
            (couponlist, Index) => {
              let sno = Index+1;
              if(couponlist.coupon_status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
              var discount = 'N/A';
              if(couponlist.discount_type == 'standard'){
                discount = '$'+couponlist.discount;
              }
              else if(couponlist.discount_type == 'percentage'){
                discount = couponlist.discount+'%';
              }
              else if(couponlist.discount_type == 'bonusFlat'){
                discount = couponlist.discount+' Credit Points';
              }
              var notifyUser = '';
              // dont show expiry coupon in send button
              const today = moment().startOf('day');
              const isExpired = moment(couponlist.valid_to).isBefore(today);
              
              
			  			  
			        var istyle = { width: 100};
              return (
                <tr key={couponlist.coupon_id}>
                  <td>{sno}</td>
                  <td>{couponlist.coupon_code}</td>
                  <td>{discount}</td>
                  <td>{moment(couponlist.valid_from).format('DD MMM YYYY')}</td>
                  <td>{moment(couponlist.valid_to).format('DD MMM YYYY')}</td>
                  {/* <td>{couponlist.total_usage}</td> */}
                  <td>{moment(couponlist.created_on).format('DD MMM YYYY')}</td>    
                  <td>
                    {!isExpired ? (
                    <div className="add_button">  
                      <a className="primary-btn" href='#'
                      onClick={this.sendCoupon.bind(this,couponlist.coupon_id)}
                      >
                        {(couponlist.notifyUser == 0) ? 
                        'Send' : 'Resend'}
                      </a> 
                    </div>) : 'N/A'} 

                  </td>
                  <td>{status}</td>
                  <td className="actiongroup">
                    <Link to={{ pathname: '/coupon-edit/'+couponlist.coupon_id}} className="" title="Duplicate">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                      <Link onClick={this.deletecoupon.bind(this,couponlist.coupon_id)} className="" title="Duplicate">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return couponlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="9" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }
  confirmPopup =(confirmstatus,coupon_id = null , popupType=null)=>{
    if(confirmstatus == 'yes'){     
      if(popupType == 'delete'){
        this.deleteConfirm(confirmstatus,coupon_id)
      }else if(popupType == 'send'){
        this.sendCouponNotification(confirmstatus,coupon_id)
      }
    }else{
      $('.confirm-action-delete').removeClass('show');	
    }
  }
  deleteConfirm =(confirmstatus,coupon_id)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
      var qs = require('qs');       
      var postObject = { 
        column: 'coupon_id',         
        value: coupon_id,   
        activePage:this.state.activePage,  
        admin_id:localStorage.getItem("admin_id")
      };
      axios.post(apiUrl+"coupon/delete",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(
          function() {
          $('.success_message').html('');
          this.setState({couponid : '', popupType: ''});
          }
          .bind(this),
          3000
          );

          this.listloadedData()
       
        }
      });  
    }else{
      $('.confirm-action-delete').removeClass('show');	
    }
  }
  sendCouponNotification =(confirmstatus,coupon_id)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
      var qs = require('qs');       
      var postObject = { 
        couponId: coupon_id,   
        admin_id:localStorage.getItem("admin_id")
      };
      axios.post(apiUrl+"coupon/sendNotification",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(function() {
            $('.success_message').html('');
            this.setState({couponid : '', popupType: ''});
          }.bind(this),3000);
          this.listloadedData()       
        }
        else{
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          
          setTimeout(function() {
            $('.success_message').html('');
            this.setState({couponid : '', popupType: ''});
          }.bind(this),3000);
        }
      });  
    }else{
      $('.confirm-action-delete').removeClass('show');	
    }
  }
  handleFilChange = (selOption) => {       	
    this.setState({selectedFilOption:selOption})
    this.setState({  selectedFilvalue : selOption.value},function(){
      this.handleFormSubmit()
    });
  };
  
  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="coupon"  currentTab="car" />  
      
      <div className="content"> 
        <div className="content-wrapper">
          <div class="content-wrapper-before"></div>
          <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
            <div className="listing-header">
              <div className="title">
                <h3>{this.state.totalRecord} Coupon{this.state.totalRecord>1 ? 's' : ''}</h3>
              </div>
              <div className='listing-header-right-sec d-flex justify-content-end gap-2 w-100'>
                <div className="search-list">
                  <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                  <div className="input_search">
                        <div className="search-inner search_input">
                          <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                          <button className="" type="submit">Submit</button>
                          <div className="erroremail"></div>
                        </div>
                        <div className="search-inner search_select">
                        <Select name="category" options={lang.common.status_filter_option} 
                          //onChange={this.handleInputChange}
                          onChange={this.handleFilChange.bind(this)}
                        />
                      </div>  
                  </div>
                </form>
                </div>
                <div className="add_button">  
                    <a className="primary-btn" href='/coupon-add'>Add</a> 
                </div>  
              </div>  
            </div>            
            {/*<div className="statusmessage"></div>*/}

            <div className="car-listing-row">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Coupon Code</th>
                    <th>Discount</th>
                    <th>Valid From</th>
                    <th>Valid Till</th>
                    {/* <th>Total Usage</th> */}
                    <th>Created On</th>
                    <th>Notify to Rider</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{this.couponlist()}</tbody>
              </Table>
              <div className="text-center">
                <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={10}
                totalItemsCount={this.state.totalRecord}
                pageRangeDisplayed={5}
                onChange={this.handlePageChange.bind(this)}
                />
              </div>
            </div>

          </div> 
        </div>  
      </div>
      
      {/* <div className="confirm-action-delete">
        <p className="confirm-action-delete-message"></p>
        <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.couponid)} className="btn">Yes</a>
        <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
        <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
      </div> */}
      <div className="confirm-action-delete">
        <p className="confirm-action-delete-message"></p>
        <a href="javascript://" onClick={this.confirmPopup.bind(this, "yes",this.state.couponid, this.state.popupType)} className="btn">Yes</a>
        <a href="javascript://" onClick={this.confirmPopup.bind(this, "No")} className="btn">No</a>
        <span class="close-support" onClick={this.confirmPopup.bind(this, "No")}  >X</span>
      </div>
    </div>
    );
  }
}

export default withRouter(List);
/*
const mapStateTopProps = (state) => {
  return {
    carlist: state.carlist,
    deletecar: state.deletecar,
	  priorityupdate: state.priorityupdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCarList: (formVal) =>{
       dispatch({ type: GET_CARLIST, formVal});
    },
    getDeleteCar: (formPayload) =>{
      dispatch({ type: GET_DELETECAR, formPayload });
    },	
	getPriorityUpdate: (formPayload) =>{
      dispatch({ type: GET_PRIORITYUPDATE, formPayload });
    }
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));*/